import React, { useEffect, useState, useMemo } from "react";
import DatePicker from "react-datepicker";
import { addDays, addMonths, parseISO, lastDayOfMonth, endOfMonth } from "date-fns";
import { fr,enUS } from "date-fns/locale";
import DatePickerCustomHeaderTwoMonth from "components/DatePickerCustomHeaderTwoMonth";
import DatePickerCustomDay from "components/DatePickerCustomDay";
import BookingDetailsSkeleton from "containers/CheckOutPage/components/skeletons/skeletonBookingDetails";
import SectionDateRangeSkeleton from "containers/ListingDetailPage/listing-stay-detail/skeleton/SectionDateSkeleton";
//translation
import { useTranslation } from "react-i18next";


interface BookingCalendarProps {
  availabilities: string[]; // format: "2025-01-04T05:00:00.000Z"
}

const TODAY = new Date();
const MAX_DATE = endOfMonth(addMonths(TODAY, 12));

const BookingCalendar: React.FC<BookingCalendarProps> = ({
  availabilities,
}) => {
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState<Date | null>(TODAY);
  const [endDate, setEndDate] = useState<Date | null>(addDays(TODAY, 5));

  // Ensure check-in/check-out dates are computed correctly
  // eslint-disable-next-line
  const { checkIn, checkOut } = useMemo(() => {
    const rangeStart = addDays(TODAY, 1);
    const rangeEnd = lastDayOfMonth(addMonths(rangeStart, 12));
    return {
      checkIn: rangeStart.toISOString().split("T")[0],
      checkOut: rangeEnd.toISOString().split("T")[0],
    };
  }, []);

  const onChangeDate = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates;
    setStartDate(start);
    setEndDate(end);
  };

  if (!availabilities || availabilities.length === 0) {
    return <SectionDateRangeSkeleton />;
  }

  const convertedDates = availabilities.map((isoDate) => {
    const [year, month, day] = isoDate.split("T")[0].split("-");
    return new Date(Number(year), Number(month) - 1, Number(day));
  });

  // Output:
  // [
  //   Date('2025-01-01T00:00:00.000'),
  //   Date('2025-01-02T00:00:00.000'),
  //   Date('2025-01-03T00:00:00.000'),
  //   Date('2025-01-04T00:00:00.000')
  // ]

  return (


      <DatePicker
        locale={enUS}
        minDate={TODAY}
        maxDate={MAX_DATE}
        onChange={onChangeDate}
        selectsRange
        monthsShown={2}
        showPopperArrow={false}
        inline
        excludeDates={convertedDates}
        renderCustomHeader={(props) => (
          <DatePickerCustomHeaderTwoMonth {...props} />
        )}
        renderDayContents={(day, date) => (
          <DatePickerCustomDay dayOfMonth={day} date={date} />
        )}
      />
   
  );
};

export default BookingCalendar;
